import React from 'react';
import { Image as ImageIcon } from 'lucide-react';

interface LogoDisplayProps {
  logoUrl?: string | null;
  alt?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  fallbackIcon?: boolean;
  rounded?: boolean;
  bordered?: boolean;
}

const LogoDisplay: React.FC<LogoDisplayProps> = ({
  logoUrl,
  alt = 'Logo',
  size = 'md',
  className = '',
  fallbackIcon = true,
  rounded = true,
  bordered = false
}) => {
  // Tailles du composant
  const sizeClasses = {
    xs: 'w-8 h-8',
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-32 h-32'
  };

  const iconSizes = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const baseClasses = `
    ${sizeClasses[size]}
    ${rounded ? 'rounded-lg' : 'rounded-none'}
    ${bordered ? 'border-2 border-gray-200' : ''}
    overflow-hidden
    bg-gray-50
    flex items-center justify-center
    ${className}
  `;

  if (!logoUrl) {
    if (fallbackIcon) {
      return (
        <div className={baseClasses}>
          <ImageIcon className={`${iconSizes[size]} text-gray-400`} />
        </div>
      );
    }
    return null;
  }

  return (
    <div className={baseClasses}>
      <img
        src={logoUrl}
        alt={alt}
        className="w-full h-full object-contain"
        onError={(e) => {
          // En cas d'erreur de chargement, afficher l'icône de fallback
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
          const parent = target.parentElement;
          if (parent) {
            parent.innerHTML = `<svg class="${iconSizes[size]} text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>`;
          }
        }}
      />
    </div>
  );
};

export default LogoDisplay;
